export default {
      id: "icon-search-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "dist/sprite.svg#icon-search",
      toString: function () {
        return this.url;
      }
    }